/*
 * Copyright (c) 2022 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";

export class RoleRightDefinitionDto extends JSONable{
  rightName: string | undefined = undefined;
  rightLabel: string | undefined = undefined;
  description: string | undefined = undefined;
  roleDefinitionUuid: string | undefined = undefined;
  selected: boolean | undefined = undefined;
  companyTypes: string[] = [];
}
